import { Directive, ElementRef, HostListener, inject } from '@angular/core';

/** Material-like ripple on press — hardware-friendly, no layout thrash */
@Directive({
  selector: '[appRipple]',
  standalone: true
})
export class RippleDirective {
  private readonly el = inject(ElementRef<HTMLElement>);

  @HostListener('pointerdown', ['$event'])
  onPointerDown(event: PointerEvent): void {
    const host = this.el.nativeElement;
    if (host.classList.contains('is-disabled') || host.hasAttribute('disabled')) return;

    const rect = host.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 1.2;
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    const ripple = document.createElement('span');
    ripple.className = 'app-ripple-ink';
    ripple.style.width = `${size}px`;
    ripple.style.height = `${size}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;

    const style = getComputedStyle(host);
    if (style.position === 'static') {
      host.style.position = 'relative';
    }
    host.classList.add('app-ripple-host');
    host.appendChild(ripple);

    window.setTimeout(() => ripple.remove(), 450);
  }
}
